export default __webpack_public_path__ + "static/media/Skirmisher's Sanctum.ac3ca10b.jpg";